/*
PHYSICAL-RISKS-SEARCH
Search risk in array
*/

import SearchBar from "@/components/search-bar"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { STATUS_SEARCHING } from "@/redux/_status.types"
import { useState, useCallback } from "react"
import physicalRiskStore from "../model/physical-risk.store"

const DEFAULT_SEARCH_COLUMNS = ["cName"]

export default function PhysicalRisksSearch() {
  const dispatch = useAppDispatch()
  const search = useAppSelector(physicalRiskStore.selectors.search)

  // Local state for SearchBar’s spinner animation
  const [isSearching, setIsSearching] = useState(false)

  const onSearch = useCallback(
    (value: string | null) => {
      const searchValue = value?.trim() ? value.trim() : null

      dispatch(
        physicalRiskStore.actions.search({
          value: searchValue,
          columns: DEFAULT_SEARCH_COLUMNS
        })
      )

      setIsSearching(false)
    },
    [dispatch]
  )

  return (
    <div className="flex-1 min-w-0">
      <SearchBar
        width="100%"
        searchText={search.value || undefined}
        onSearch={onSearch}
        status={isSearching ? STATUS_SEARCHING : undefined}
        onSearchStart={() => setIsSearching(true)}
      />
    </div>
  )
}
